// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'font-awesome/css/font-awesome.css';
import store from '@/models/store.js';

// component
import Info from '@/components/parts/Information';
import ItemTable from '@/components/parts/ItemTable';
import ShowHiddenItemBtn from '@/components/parts/ShowHiddenItemBtn';
import ButtonBar from '@/components/parts/ButtonBar';

Vue.config.productionTip = false;
Vue.use(VueMaterial);
Vue.use(BootstrapVue);
// component
Vue.component('Info', Info);
Vue.component('ItemTable', ItemTable);
Vue.component('ShowHiddenItemBtn', ShowHiddenItemBtn);
Vue.component('ButtonBar', ButtonBar);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js